import { Component, Input, OnInit } from "@angular/core";
import { SurveyOrderContent, Task } from "../../shared/task";

export interface TaskWithSurveyOrderContent extends Task {
  content: SurveyOrderContent;
}

@Component({
  selector: "om-survey-order-details",
  templateUrl: "./survey-order-details.component.html",
  styleUrls: ["./survey-order-details.component.scss", "../_shared-task-details.scss"],
})
export class SurveyOrderDetailsComponent implements OnInit {
  @Input() task: TaskWithSurveyOrderContent;

  ngOnInit() {}
}
